import Lottie from "react-lottie";
import style from "./styles/Global.module.scss";
// Utils
import lottieDefaultOptions from "../../../utils/configs/lottie";
import * as animationData from "../../../utils/suspense-loader.json";

const GlobalSuspense = () => {
  return (
    <div className={style["global-suspense"]}>
      <Lottie
        options={{ ...lottieDefaultOptions, animationData }}
        height={200}
        width={200}
      />
    </div>
  );
};

export default GlobalSuspense;
